import React from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { generateChartColor, fold } from "../../../../helpers/chartHelper";
import { adjustContentHeight } from "../../../../helpers/viewPortHelper";
import { DateRange } from "@material-ui/icons";
import { colorHelper } from "../../../../helpers/colorHelper";
import './RatingChart.css'

export const RatingChart = ({ data, questionName, template }) => {
    let dataArr = [];
    let sum = 0;
    data.map((a) => sum += parseInt(a))
    let average = Math.round((sum / data.length) * 10) / 10;
    dataArr.push({
        name: average,
        y: average,
        /*   percentage: `${(count / data.length) * 100}`, */
        color: generateChartColor(template.chart.colors),
        sliced: true
    });


    let w = window.innerWidth * (parseInt(template.content.maxWidth) / 100);
    let h = adjustContentHeight(
        window.innerHeight,
        template.content,
        template.header,
        template.footer
    );
    questionName =
        questionName.length > 50
            ? fold(questionName, 50, true).join("<br/>")
            : questionName;

    const options = {
        chart: {
            backgroundColor: "transparent",
            plotBorderWidth: null,
            plotShadow: false,
            plotBackgroundColor: "transparent",
            type: "column",
            height: h,
            width: w,
            style: {
                padding: 10
            }
        },
        title: {
            text: questionName,
            style: { ...template.title, textAlign: "center" }
        },
        legend: {
            enabled: false,
            title: {
                text: null
            }
        },
        yAxis: {
            min: 0,
            max: 10,
            tickInterval: 1,
            /*       categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'], */
            allowDecimals: false,
            title: {
                text: null
            },
            labels: {
                style: {
                    fontSize: template.label.fontSize,
                    fontFamily: template.label.fontFamily,
                    color: template.label.color
                }
            }
        },
        xAxis: {
            /*      categories: [average], */
            allowDecimals: true,
            title: {
                text: null
            },
            labels: {
                enabled: false,
                align: 'center',
                /*     y: -15, */
                style: {
                    fontSize: template.label.fontSize,
                    fontFamily: template.label.fontFamily,
                    color: template.label.color

                }
            }
            /*   labels:{
                        enabled: false
                    } */
        },
        tooltip: {
            pointFormat: "{point.name} <br>{point.percentage:.1f} %"
        },
        plotOptions: {
            series: {
                dataLabels: {
                    /*    enabled: true, */
                    color: colorHelper.getCorrectTextColor(generateChartColor(template.chart.colors)),
                    style: {
                        fontWeight: 'bolder'
                    },
                    formatter: function () { return this.y },
                    inside: true,
                    rotation: 0
                },
                stacking: "normal",
                pointPadding: 0.1,
                groupPadding: 0
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                dataLabels: {
                    enabled: true,
                    inside: true,
                    style: {
                        fontWeight: 'bolder', fontSize: template.title.fontSize,
                        fontFamily: template.title.fontFamily,
                        color: colorHelper.getCorrectTextColor(generateChartColor(template.chart.colors)) + '!important',
                        fill: colorHelper.getCorrectTextColor(generateChartColor(template.chart.colors)) + ' !important',
                        stroke: colorHelper.getCorrectTextColor(generateChartColor(template.chart.colors)) + ' !important'
                    }
                },
                colorByPoint: true,
                data: dataArr /* .sort((a, b) => { return a.y - b.y }) */,
                showInLegend: false
            }
        ]
    };

    return (
        <React.Fragment>
            {/*     <div ref={r => this.chartHeader}>  
                <h1 style={{ ...template.title, textAlign: 'center' }}>{questionName}</h1>
                <br />
            </div> */}
            <div style={{ display: "flex", justifyContent: "center" }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
            {/*     <PieRechart width={w} height={h} style={{ margin: 'auto' }}>
                <Pie style={{ fontSize: '18px' }} data={dataArr} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={200} fill="#82ca9d" label={renderLabel} >
                    {dataArr.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]} />)}
                  
                </Pie>
            </PieRechart> */}
        </React.Fragment>
    );
};
